/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable camelcase */
/**
 * Conversations page functionality
 * Handles the "Mijn Gesprekken" page with sidebar list and chat interface
 */

let $conversationsList;
let $conversationChat;
let $deleteConversationModal;
let currentConversationId = null;
let pendingDeleteConversationId = null;
const CONVERSATION_SCROLL_THRESHOLD = 5;
const conversationsPageI18n = (typeof window !== 'undefined' && window.novioI18n && window.novioI18n.conversations_page)
  ? window.novioI18n.conversations_page
  : {};

function conversationsPageT(key, replacements = {}) {
  let value = typeof conversationsPageI18n[key] === 'string' ? conversationsPageI18n[key] : key;

  Object.keys(replacements).forEach((replacementKey) => {
    const token = `{${replacementKey}}`;
    value = value.split(token).join(replacements[replacementKey]);
  });

  return value;
}

/**
 * Scroll chat messages to bottom
 */
function scrollToBottom() {
  const $messagesContainer = $('.js-messages-container');
  if ($messagesContainer.length) {
    $messagesContainer.scrollTop($messagesContainer[0].scrollHeight);
  }
}

function getAjaxErrorMessage(response, fallbackMessage) {
  if (response && response.status === 429) {
    const retryAfter = response.responseJSON && response.responseJSON.retry_after;
    if (retryAfter) {
      return conversationsPageT('rate_limited_retry', { seconds: retryAfter });
    }
    return conversationsPageT('rate_limited');
  }

  if (response && response.responseJSON && response.responseJSON.message) {
    return response.responseJSON.message;
  }

  return fallbackMessage;
}

function syncReadSpeakerUrlToCurrentPage() {
  const readSpeakerLink = document.querySelector('#readspeaker_button1 .rsbtn_play');
  if (!readSpeakerLink) {
    return;
  }

  const href = readSpeakerLink.getAttribute('href');
  if (!href) {
    return;
  }

  let readSpeakerUrl;
  try {
    readSpeakerUrl = new URL(href, window.location.origin);
  } catch (error) {
    return;
  }

  readSpeakerUrl.searchParams.set('url', window.location.href);
  readSpeakerLink.setAttribute('href', readSpeakerUrl.toString());
}

function resetReadSpeakerIfActive() {
  if (!window.rspkr || !window.rspkr.ui || typeof window.rspkr.ui.destroyActivePlayer !== 'function') {
    return;
  }

  window.rspkr.ui.destroyActivePlayer();
}

function emitConversationLoadedEvent(conversationId) {
  document.dispatchEvent(new CustomEvent('novio:conversation-loaded', {
    detail: {
      conversationId,
      url: window.location.href,
    },
  }));
}

/**
 * Select and load a conversation
 */
function selectConversation(conversationId) {
  currentConversationId = conversationId;

  // Update selected state in sidebar
  $('.js-conversation-card').removeClass('c-conversations__card--selected');
  $(`.js-conversation-card[data-conversation-id="${conversationId}"]`).addClass(
    'c-conversations__card--selected',
  );

  // Show loading state
  $conversationChat.html('<div class="c-loader__spinner"><i class="fas fa-circle-notch fa-spin"></i></div>');

  // Load conversation messages
  // eslint-disable-next-line no-undef
  const ajax_url = typeof linku_ajax_url !== 'undefined' ? linku_ajax_url : '/wp/wp-admin/admin-ajax.php';

  $.ajax({
    url: ajax_url,
    type: 'post',
    data: {
      action: 'get_conversation_messages',
      conversation_id: conversationId,
    },
    dataType: 'json',
    success(response) {
      if (response.success) {
        $conversationChat.html(response.chat_html);
        scrollToBottom();

        // Update URL without reload
        const url = new URL(window.location);
        url.searchParams.set('conversation', conversationId);
        window.history.replaceState({}, '', url);

        syncReadSpeakerUrlToCurrentPage();
        resetReadSpeakerIfActive();
        emitConversationLoadedEvent(conversationId);
      } else {
        $conversationChat.html(`<p class="c-conversations__error">${conversationsPageT('cannot_load_conversation')}</p>`);
      }
    },
    error(response) {
      console.error('Error loading conversation:', response);
      $conversationChat.html(
        `<p class="c-conversations__error">${getAjaxErrorMessage(
          response,
          conversationsPageT('generic_error'),
        )}</p>`,
      );
    },
  });
}

/**
 * Load all conversations for the current user
 */
function loadConversations() {
  // Read conversation ID from URL to ensure it's up-to-date
  const urlParams = new URLSearchParams(window.location.search);
  const conversationParam = urlParams.get('conversation');
  const selectedId = conversationParam ? parseInt(conversationParam, 10) : (currentConversationId || null);

  // eslint-disable-next-line no-undef
  const ajax_url = typeof linku_ajax_url !== 'undefined' ? linku_ajax_url : '/wp/wp-admin/admin-ajax.php';

  $.ajax({
    url: ajax_url,
    type: 'post',
    data: {
      action: 'get_conversations',
      selected_conversation_id: selectedId,
    },
    dataType: 'json',
    success(response) {
      if (response.success) {
        $conversationsList.html(response.html);
        // updateConversationsSidebarScrollState();

        // Check slider status after content is loaded
        setTimeout(() => {
          checkConversationsSliderStatus();
        }, 0);

        // Select conversation - server-side rendering already adds the class,
        // but we still need to call selectConversation() to load messages
        if (selectedId) {
          currentConversationId = selectedId;
          selectConversation(selectedId);
        } else if (response.conversations && response.conversations.length > 0) {
          selectConversation(response.conversations[0].id);
        }
      } else {
        $conversationsList.html(`<p class="c-conversations__error">${conversationsPageT('cannot_load_conversations')}</p>`);
      }
    },
    error(response) {
      console.error('Error loading conversations:', response);
      $conversationsList.html(
        `<p class="c-conversations__error">${getAjaxErrorMessage(
          response,
          conversationsPageT('generic_error'),
        )}</p>`,
      );
    },
  });
}

/**
 * End a conversation
 */
function endConversation(conversationId) {
  // eslint-disable-next-line no-undef
  const ajax_url = typeof linku_ajax_url !== 'undefined' ? linku_ajax_url : '/wp/wp-admin/admin-ajax.php';

  $.ajax({
    url: ajax_url,
    type: 'post',
    data: {
      action: 'end_conversation',
      conversation_id: conversationId,
    },
    dataType: 'json',
    success(response) {
      if (response.success) {
        // Remove from sidebar
        $(`.js-conversation-card[data-conversation-id="${conversationId}"]`).fadeOut(200, function onCardFadeOut() {
          $(this).remove();
          // updateConversationsSidebarScrollState();

          // Check slider status after item is removed
          checkConversationsSliderStatus();

          // Clear chat area or select another conversation
          const $remainingCards = $('.js-conversation-card');
          if ($remainingCards.length > 0) {
            selectConversation($remainingCards.first().data('conversation-id'));
          } else {
            $conversationChat.html(
              `<div class="c-conversations__empty-state"><p>${conversationsPageT('no_conversations_left')}</p></div>`,
            );
          }
        });
      } else {
        alert(response.message || conversationsPageT('end_error'));
      }
    },
    error(response) {
      console.error('Error ending conversation:', response);
      alert(getAjaxErrorMessage(response, conversationsPageT('end_error')));
    },
  });
}

function openDeleteConversationModal(conversationId) {
  if ($deleteConversationModal.length === 0) {
    endConversation(conversationId);
    return;
  }

  pendingDeleteConversationId = conversationId;
  $deleteConversationModal.removeAttr('hidden').addClass('is-open');
}

function closeDeleteConversationModal() {
  pendingDeleteConversationId = null;
  $deleteConversationModal.removeClass('is-open').attr('hidden', 'hidden');
}

function confirmDeleteConversation() {
  if (!pendingDeleteConversationId) {
    return;
  }

  const conversationId = pendingDeleteConversationId;
  closeDeleteConversationModal();
  endConversation(conversationId);
}

/**
 * Send a message in the current conversation
 */
function sendMessage($form) {
  const conversationId = $form.data('conversation-id');
  const $input = $form.find('.js-message-input');
  const $button = $form.find('.js-send-message');
  const message = $input.val().trim();

  if (!message) {
    return;
  }

  // Disable input while sending
  $input.prop('disabled', true);
  $button.prop('disabled', true).html('<i class="fas fa-circle-notch fa-spin"></i>');

  // eslint-disable-next-line no-undef
  const ajax_url = typeof linku_ajax_url !== 'undefined' ? linku_ajax_url : '/wp/wp-admin/admin-ajax.php';

  $.ajax({
    url: ajax_url,
    type: 'post',
    data: {
      action: 'send_message',
      conversation_id: conversationId,
      message,
    },
    dataType: 'json',
    success(response) {
      if (response.success) {
        // Add message to chat
        const $messagesContainer = $('.js-messages-container');
        $messagesContainer.append(response.message_html);

        // Clear input
        $input.val('');
        $input.css('height', 'auto');

        // Scroll to bottom
        scrollToBottom();
      } else {
        alert(response.message || conversationsPageT('send_error'));
      }

      // Re-enable input
      $input.prop('disabled', false);
      $button.prop('disabled', false).html('<i class="fas fa-arrow-right"></i>');
      $input.focus();
    },
    error(response) {
      console.error('Error sending message:', response);
      alert(getAjaxErrorMessage(response, conversationsPageT('send_error')));

      // Re-enable input
      $input.prop('disabled', false);
      $button.prop('disabled', false).html('<i class="fas fa-arrow-right"></i>');
    },
  });
}

function checkConversationsSliderStatus() {
  const $conversationsSlider = $('.js-conversations-slider');
  const windowWidth = $(window).width();
  const isLargeScreen = windowWidth >= 992; // 991px + 1px to match CSS breakpoint

  $conversationsSlider.each(function checkSlider() {
    const $slider = $(this);
    const $sliderItems = $slider.find('.js-conversations-list');
    const $sliderNext = $slider.find('.js-conversations-slider-next');
    const $sliderPrev = $slider.find('.js-conversations-slider-prev');
    const $sliderNavigation = $slider.find('.js-conversations-slider-navigation');
    const itemContainerWidth = $sliderItems.outerWidth();
    let itemsWidth = 0;

    // Verberg navigatie op grote schermen (>= 992px)
    if (isLargeScreen) {
      $sliderNavigation.hide();
      return;
    }

    // Bereken de totale breedte van de items in de slider
    $sliderItems.children().each(function calculateWidth() {
      itemsWidth += $(this).outerWidth(true);
    });

    // Voeg een class toe aan de slider en schakel knoppen in/uit
    if (itemsWidth > itemContainerWidth) {
      $slider.addClass('has-slider');
      $sliderNavigation.show();

      const isAtBeginning = $sliderItems.scrollLeft() === 0;
      const endOfSlider = $sliderItems.scrollLeft() + $sliderItems.width();
      const isAtEnd = endOfSlider === $sliderItems[0].scrollWidth;

      $sliderNext.prop('disabled', isAtEnd);
      $sliderPrev.prop('disabled', isAtBeginning);
    } else {
      $slider.removeClass('has-slider');
      $sliderNavigation.hide();
      $sliderNext.prop('disabled', true);
      $sliderPrev.prop('disabled', true);
    }
  });
}

function initConversationsSlider() {
  const $conversationsSlider = $('.js-conversations-slider');
  let resizeTimer;
  const sliderSpacing = 24;
  let scrollTimer;
  let isScrolling = false;

  // Voer de check bij het laden van de pagina uit
  checkConversationsSliderStatus();

  // Voeg een event listener toe voor het resize evenement
  $(window).on('resize', () => {
    // Wacht kort na het eindigen van het resize evenement voordat je de check uitvoert
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      checkConversationsSliderStatus();
    }, 200);
  });

  $conversationsSlider.each(function initSlider() {
    const $slider = $(this);
    const $sliderNext = $slider.find('.js-conversations-slider-next');
    const $sliderPrev = $slider.find('.js-conversations-slider-prev');
    const $itemContainer = $slider.find('.js-conversations-list');

    // Function to check the button status
    function checkButtonStatus() {
      const margin = 20; // Adjust this value as needed
      $slider.find('.js-conversations-slider-next').prop('disabled', $itemContainer.scrollLeft() + $itemContainer.width() + margin >= $itemContainer[0].scrollWidth);
      $slider.find('.js-conversations-slider-prev').prop('disabled', $itemContainer.scrollLeft() <= margin);
    }

    // Function that adds class is-animating, set new position, and removes class is-animating
    function setNewPosition(newLeft) {
      $itemContainer.addClass('is-animating');
      $itemContainer.animate({ scrollLeft: newLeft }, 300, () => {
        checkButtonStatus();
        $itemContainer.removeClass('is-animating');
      });
    }
    console.log($sliderNext);
    $sliderNext.on('click', (e) => {
      console.log(e);
      const $sliderItems = $itemContainer.children();
      const currentLeft = $itemContainer.scrollLeft();
      const itemWidth = $sliderItems.outerWidth();
      const newLeft = currentLeft + itemWidth + sliderSpacing;

      setNewPosition(newLeft);
    });

    $sliderPrev.on('click', (e) => {
      console.log(e);
      const $sliderItems = $itemContainer.children();
      const currentLeft = $itemContainer.scrollLeft();
      const itemWidth = $sliderItems.outerWidth();
      const newLeft = currentLeft - itemWidth - sliderSpacing;

      setNewPosition(newLeft);
    });

    // Function to handle scroll events
    $itemContainer.on('scroll', () => {
      isScrolling = true;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        if (isScrolling) {
          checkButtonStatus();
        }
      }, 100);
    });
  });
}

$(document).ready(($) => {
  $conversationsList = $('.js-conversations-list');
  $conversationChat = $('.js-conversation-chat');
  $deleteConversationModal = $('.js-conversation-delete-modal');

  initConversationsSlider();

  // Only run on conversations page
  if ($conversationsList.length === 0) {
    return;
  }

  // Check URL for pre-selected conversation
  const urlParams = new URLSearchParams(window.location.search);
  const conversationParam = urlParams.get('conversation');
  if (conversationParam) {
    currentConversationId = parseInt(conversationParam, 10);
  }

  // Load conversations on page load
  loadConversations();

  // Click on conversation card
  $(document).on('click', '.js-conversation-card', function handleConversationCardClick() {
    const conversationId = $(this).data('conversation-id');
    selectConversation(conversationId);
  });

  // Submit message form
  $(document).on('submit', '.js-message-form', function handleMessageFormSubmit(e) {
    e.preventDefault();
    sendMessage($(this));
  });

  // End conversation button
  $(document).on('click', '.js-end-conversation', (e) => {
    if (window.getSelection && window.getSelection().toString()) {
      return;
    }

    const conversationId = $(e.currentTarget).data('conversation-id');
    openDeleteConversationModal(conversationId);
  });

  $(document).on(
    'click',
    '.js-conversation-delete-cancel, .js-conversation-delete-modal-close',
    (e) => {
      e.preventDefault();
      closeDeleteConversationModal();
    },
  );

  $(document).on('click', '.js-conversation-delete-confirm', (e) => {
    e.preventDefault();
    confirmDeleteConversation();
  });

  $(document).on('keydown', (e) => {
    if (e.key === 'Escape' && $deleteConversationModal.hasClass('is-open')) {
      closeDeleteConversationModal();
    }
  });

  // Auto-resize textarea
  $(document).on('input', '.js-message-input', function resizeMessageInput() {
    this.style.height = 'auto';
    this.style.height = `${Math.min(this.scrollHeight, 120)}px`;
  });
});
